import { useState } from 'react';
import { useStudentData } from '@/hooks/useStudentData';

export default function StudentWhatsapp() {
  const { group, whatsappLink, loading, error, refetch } = useStudentData();
  const [copied, setCopied] = useState(false);

  async function copyLink() {
    if (!whatsappLink) return;
    try {
      await navigator.clipboard.writeText(whatsappLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Pano erişimi engelliyse sessizce geç.
    }
  }

  if (loading) {
    return (
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-center py-20">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-500" />
        <p className="mt-4 text-sm text-foreground-500">WhatsApp grubu yükleniyor...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mx-auto max-w-5xl py-10">
        <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-center">
          <i className="ri-error-warning-line text-2xl text-red-500" />
          <p className="mt-2 text-sm font-medium text-red-700">Gruplar yüklenirken bir hata oluştu.</p>
          <p className="mt-1 text-xs text-red-500">{error}</p>
          <button type="button" onClick={refetch} className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-600 cursor-pointer">
            <i className="ri-refresh-line" /> Yeniden Dene
          </button>
        </div>
      </div>
    );
  }

  if (!group) {
    return (
      <div className="mx-auto max-w-5xl space-y-6">
        <div>
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">WhatsApp Grubum</h1>
          <p className="mt-1 text-sm text-foreground-600">Ders grubunuza katılmak için aşağıdaki linki kullanın.</p>
        </div>
        <div className="rounded-xl border border-background-200 bg-white p-10 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50">
            <i className="ri-whatsapp-line text-2xl text-emerald-500" />
          </div>
          <p className="text-sm font-semibold text-foreground-700">Henüz size atanmış bir grup bulunmuyor.</p>
          <p className="mt-1 text-xs text-foreground-500">Ders içerikleriniz tanımlandığında burada görünecek.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">WhatsApp Grubum</h1>
        <p className="mt-1 text-sm text-foreground-600">Ders grubunuza katılmak için aşağıdaki linki kullanın.</p>
      </div>

      <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-6">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
            <i className="ri-team-line text-xl" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-semibold text-emerald-600">Sınıf Grubunuz</p>
            <h3 className="font-semibold text-foreground-950 text-sm leading-tight">{group.name}</h3>
            {group.level && <p className="mt-0.5 text-xs text-foreground-500">{group.level}</p>}
          </div>
        </div>

        {whatsappLink ? (
          <div className="mt-4 flex flex-col gap-2 sm:flex-row">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-emerald-500 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-600"
            >
              <i className="ri-whatsapp-line" /> Gruba Katıl
            </a>
            <button
              type="button"
              onClick={copyLink}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-emerald-200 bg-white px-4 py-2.5 text-sm font-semibold text-emerald-700 transition hover:bg-emerald-100 cursor-pointer"
            >
              <i className={copied ? 'ri-check-line' : 'ri-link'} />
              {copied ? 'Kopyalandı' : 'Linki Kopyala'}
            </button>
          </div>
        ) : (
          <p className="mt-4 rounded-lg bg-white/70 px-4 py-3 text-sm text-foreground-600">
            Grubunuz için henüz WhatsApp bağlantısı eklenmemiş.
          </p>
        )}
      </div>
    </div>
  );
}